import { THEME_COLORS, STATUS_COLORS, TONE_COLORS } from './colors';

export type UoHubAction = {
  labelKey: string;
  labelFallback: string;
  sublabelKey: string;
  sublabelFallback: string;
  route: string;
  icon: string;
  tone: 'blue' | 'green' | 'gold' | 'muted';
};

export type UoHubSection = {
  titleKey: string;
  titleFallback: string;
  badge: string;
  tone: 'blue' | 'green' | 'gold';
  actions: UoHubAction[];
};

export type UoHubStat = {
  valueKey?: string;
  valueFallback: string;
  labelKey: string;
  labelFallback: string;
  tone: 'blue' | 'green' | 'gold';
  icon: string;
};

export const UOHUB_COLORS = {
  ...THEME_COLORS,
  heroTitle: THEME_COLORS.titleGradient,
  heroTitleShadow: '0 0 12px rgba(49,47,6,0.85)',
  statDivider: 'linear-gradient(180deg, transparent 0%, #ADD741 52.4%, transparent 100%)',
  liveBg: 'rgba(173,215,65,0.12)',
  tones: TONE_COLORS,
} as const;

export const UOHUB_STATS: UoHubStat[] = [
  {
    valueFallback: '—',
    labelKey: 'uoHub.statSubAccounts',
    labelFallback: '子账户',
    tone: 'gold',
    icon: '/brand/me/group_add.svg',
  },
  {
    valueFallback: '—',
    labelKey: 'uoHub.statHallOrders',
    labelFallback: '大厅成交',
    tone: 'green',
    icon: '/brand/assets/uo-trading.png',
  },
];

/** UO 交易 tab — 会员注册 / 子账户 / UO 挂卖（与 EP1/EP2 无关） */
export const UOHUB_SECTIONS: UoHubSection[] = [
  {
    titleKey: 'uoHub.memberSection',
    titleFallback: '会员与子账户',
    badge: 'ORB',
    tone: 'gold',
    actions: [
      {
        labelKey: 'uoHub.registerMember',
        labelFallback: '注册新会员',
        sublabelKey: 'uoHub.registerMemberSub',
        sublabelFallback: '左/右区安置 · 网体下线',
        route: '/register-member',
        icon: '/brand/me/group_add.svg',
        tone: 'gold',
      },
      {
        labelKey: 'uoHub.openSubAccount',
        labelFallback: '开子账户',
        sublabelKey: 'uoHub.openSubAccountSub',
        sublabelFallback: '大区安置 · 资产切换',
        route: '/open-sub-account',
        icon: '/brand/me/group_add.svg',
        tone: 'green',
      },
      {
        labelKey: 'uoHub.subAccounts',
        labelFallback: '子账户管理',
        sublabelKey: 'uoHub.subAccountsSub',
        sublabelFallback: '切换子号 · 查看余额',
        route: '/sub-accounts',
        icon: '/brand/me/subtasks.svg',
        tone: 'blue',
      },
      {
        labelKey: 'uoHub.binaryTree',
        labelFallback: '网体安置',
        sublabelKey: 'uoHub.binaryTreeSub',
        sublabelFallback: '左/右区 · 大区规则',
        route: '/tree',
        icon: '/brand/me/people.svg',
        tone: 'muted',
      },
      {
        labelKey: 'uoHub.nearbyPlayers',
        labelFallback: '附近玩家',
        sublabelKey: 'uoHub.nearbyPlayersSub',
        sublabelFallback: '我的好友 · 直推列表',
        route: '/nearby',
        icon: '/brand/me/group_add.svg',
        tone: 'blue',
      },
      {
        labelKey: 'uoHub.globalPlayers',
        labelFallback: '全球玩家',
        sublabelKey: 'uoHub.globalPlayersSub',
        sublabelFallback: '网体下线表 · 点击ID筛选',
        route: '/all-users',
        icon: '/brand/me/people.svg',
        tone: 'green',
      },
    ],
  },
  {
    titleKey: 'uoHub.marketSection',
    titleFallback: 'ORB 挂卖交易',
    badge: 'OTC',
    tone: 'green',
    actions: [
      {
        labelKey: 'uoHub.tradingHall',
        labelFallback: 'ORB 交易大厅',
        sublabelKey: 'uoHub.tradingHallSub',
        sublabelFallback: '成交记录 · 盘口',
        route: '/trading',
        icon: '/brand/assets/uo-trading.png',
        tone: 'green',
      },
      {
        labelKey: 'uoHub.sellUo',
        labelFallback: '出售 ORB',
        sublabelKey: 'uoHub.sellUoSub',
        sublabelFallback: '限价挂卖 · 主账户',
        route: '/sell-uo',
        icon: '/brand/icons/sell-uo.png',
        tone: 'gold',
      },
      {
        labelKey: 'uoHub.myOrders',
        labelFallback: '我的买卖',
        sublabelKey: 'uoHub.myOrdersSub',
        sublabelFallback: '挂单 · 成交记录',
        route: '/trading/orders',
        icon: '/brand/me/order.svg',
        tone: 'blue',
      },
    ],
  },
];
